var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper"},[_c('button',{ref:"button",staticClass:"transition-all py-2 px-3 inline-flex items-center gap-2 text-sm hover:text-gray-700 font-medium rounded-md hover:hover:text-blue-600",class:{
      [_vm.$parent.value === _vm.name
        ? 'bg-white text-blue-500'
        : 'bg-transparent text-gray-500']: true, ['opacity-40 cursor-not-allowed']: _vm.disabled
    },on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$parent.value === _vm.name),expression:"$parent.value === name"}],ref:"body",staticClass:"h-full"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }